const filter = document.querySelector(".js-nav");
const filterToggles = document.querySelectorAll(".js-nav-toggle");

/** Toggles */
const attachFilterToggle = (filterToggle: Element): void => {
  filterToggle.addEventListener("click", () => {
    if (document.body.classList.toggle("is-nav-active")) {
      window.scrollTo({
        top: 0,
        left: 0,
      });
    }
  });
};

filterToggles.forEach(attachFilterToggle);
